import { render } from "./ConfirmationComponent.vue?vue&type=template&id=a7fc9858&ts=true"
import script from "./ConfirmationComponent.vue?vue&type=script&lang=ts"
export * from "./ConfirmationComponent.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src2281535322/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__